/**
 * Routendefinition. Die Pfade sind deutsch (siehe Plan).
 *
 * Meta-Flags:
 *  - `public`     – ohne Anmeldung erreichbar (Impressum, 404)
 *  - `guestOnly`  – nur für Abgemeldete (Anmeldeseite)
 *  - `requiresAdmin` – zusätzlich `role === 'admin'`
 *  - `chrome: false` – Shell (Kopfleiste/Navigation) ausblenden (Druckrouten)
 *  - `title`      – Dokumenttitel ohne Suffix
 */
import type { RouteRecordRaw } from 'vue-router'

import { de } from '@/strings/de'

declare module 'vue-router' {
  interface RouteMeta {
    /** Ohne Anmeldung erreichbar. */
    public?: boolean
    /** Nur für Abgemeldete. */
    guestOnly?: boolean
    /** Zusätzlich Administratorrolle nötig. */
    requiresAdmin?: boolean
    /** `false` blendet die App-Shell aus (Druckansichten). */
    chrome?: boolean
    /** Dokumenttitel ohne " – SELWA für Therapeuten". */
    title?: string
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/anmelden',
    name: 'signin',
    component: () => import('@/views/SignInView.vue'),
    meta: { public: true, guestOnly: true, chrome: false, title: de.auth.signInTitle },
  },
  {
    path: '/',
    name: 'patients',
    component: () => import('@/views/PatientListView.vue'),
    meta: { title: de.nav.patients },
  },
  {
    path: '/patienten/neu',
    name: 'patient-new',
    component: () => import('@/views/NewPatientView.vue'),
    meta: { title: de.newPatient.title },
  },
  {
    path: '/patienten/:id(\\d+)',
    name: 'patient-detail',
    component: () => import('@/views/PatientDetailView.vue'),
    props: true,
    meta: { title: de.patient.heading },
  },
  {
    path: '/patienten/:id(\\d+)/druck',
    name: 'patient-print',
    component: () => import('@/views/PatientLogPrintView.vue'),
    props: true,
    meta: { chrome: false, title: de.patient.actions.print },
  },
  {
    path: '/patienten/:id(\\d+)/infoblatt',
    name: 'patient-infosheet',
    component: () => import('@/views/PatientInfoSheetView.vue'),
    props: true,
    meta: { chrome: false, title: de.print.infoSheet.title },
  },
  {
    path: '/lizenz',
    name: 'license',
    component: () => import('@/views/LicenseView.vue'),
    meta: { title: de.license.title },
  },
  {
    path: '/impressum',
    name: 'imprint',
    component: () => import('@/views/ImprintView.vue'),
    meta: { public: true, title: de.imprint.title },
  },
  {
    path: '/verwaltung/therapeuten',
    name: 'admin-therapists',
    component: () => import('@/views/AdminTherapistsView.vue'),
    meta: { requiresAdmin: true, title: de.admin.therapists.title },
  },
  {
    path: '/verwaltung/lizenzen',
    name: 'admin-licenses',
    component: () => import('@/views/AdminLicensesView.vue'),
    meta: { requiresAdmin: true, title: de.admin.licenses.title },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue'),
    meta: { public: true, title: de.common.notFoundTitle },
  },
]

export default routes
